import en from "./en";
import zh from "./zh";
import zhTW from "./zh-TW";
export default {
    en,
    zh,
    zhTW
};